@if (actions().length) {
    <div
        ngbDropdown
        class="anc-action-menu"
        display="dynamic"
        container="body"
        [placement]="effectivePlacement()"
        [popperOptions]="popperOptions"
    >
        <button
            type="button"
            class="anc-action-menu__trigger"
            ngbDropdownToggle
            [disabled]="disabled()"
            aria-label="Actions"
        >
            <i
                class="icon icon--24 icon-more-menu anc-action-menu__trigger-icon"
                aria-hidden="true"
            ></i>
        </button>

        <div ngbDropdownMenu class="anc-action-menu__list">
            @for (action of actions(); track action.id) {
                <button
                    type="button"
                    ngbDropdownItem
                    class="anc-action-menu__item"
                    [class.anc-action-menu__item--danger]="action.danger"
                    [disabled]="action.disabled"
                    (click)="onItem(action)"
                >
                    @if (action.icon) {
                        <span class="anc-action-menu__icon icon" [ngClass]="action.icon"></span>
                    }
                    <span class="anc-action-menu__label">{{ action.label | translate }}</span>
                </button>
            }
        </div>
    </div>
}
